import dayjs from 'dayjs';
import _ from 'lodash';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError } from 'src/common/helpers/Notifications';
import {
  fetchCombinedDataParallellyAsync,
  fetchDataParallellyAsync,
} from 'src/common/helpers/Utils';
import {
  HISTORY_DATA_MANAGEMENT_ACTIONS,
  getHistoryDataError,
  getHistoryDataSuccess,
} from './actions';

function* getHistoryData({ payload }) {
  try {
    let startDatetime = new Date(payload.startTime);
    let endDatetime = new Date(payload.endTime);
    let startISOStr = dayjs(
      startDatetime.setUTCHours(startDatetime.getUTCHours() + 9)
    )
      .toISOString()
      .replace(/\.\d+Z$/, '+09:00');
    let endISOStr = dayjs(
      endDatetime.setUTCHours(endDatetime.getUTCHours() + 9)
    )
      .toISOString()
      .replace(/\.\d+Z$/, '+09:00');

    const combinedUrl = `${ApiConstants.BASE_URL}${ApiConstants.HISTORY_COMBINED_DATA}?startTime=${startISOStr}&endTime=${endISOStr}`;
    const tasks = [
      fetchCombinedDataParallellyAsync(requests.getRequest, combinedUrl),
    ];

    // fetch today data in case the time range contains today time
    const today = new Date();
    const todayStart = dayjs(today).startOf('D');
    if (dayjs(endDatetime).valueOf() >= todayStart.valueOf()) {
      let todayStartTime = dayjs(today).format('YYYY-MM-DD 00:00');

      if (dayjs(startDatetime).isAfter(todayStart)) {
        todayStartTime = payload.startTime;
      }

      const url = `${ApiConstants.BASE_URL}${ApiConstants.HISTORY_DATA_MANAGEMENT}?startTime=$start$&endTime=$end$`;
      tasks.push(
        fetchDataParallellyAsync(
          requests.getRequest,
          url,
          dayjs(todayStartTime),
          dayjs(payload.endTime),
          60
        )
      );
    }
    //

    // waiting for all tasks done
    const responses = yield Promise.all(tasks);

    let records = responses.flat();

    // filter by start and end time
    records = records.filter(
      (x) =>
        dayjs(x.tsp) >= dayjs(payload.startTime) &&
        dayjs(x.tsp) <= dayjs(payload.endTime)
    );

    // format datetime
    records.forEach((record) => {
      record.tsp = dayjs(record.tsp).format('YYYY/MM/DD HH:mm:ss');
    });

    // unique by time and history id
    _.uniqBy(records, (record) => `${record.tsp}-${record.hid}`);

    // sort records by time
    records = _.orderBy(records, ['tsp']);

    yield put(getHistoryDataSuccess(records));
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(getHistoryDataError(e));
  }
}

export function* CSVDataManagementSaga() {
  yield takeLatest(
    HISTORY_DATA_MANAGEMENT_ACTIONS.GET_HISTORY_DATA,
    getHistoryData
  );
}

export default function* rootSaga() {
  yield all([fork(CSVDataManagementSaga)]);
}
